import { Box } from "theme-ui"
import "./style/style.css"
import logo from "./logo.png"
import { Button, Language, SignInLoader } from "components"
import { useForm, SubmitHandler } from "react-hook-form"
import { useLoginMutation } from "../../store/Features/auth/login-api-splice"

import cookie from "react-cookies"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
type FormValues = {
 email: string
 password: string
 grant_type: string | null
 scope: string | null
 client_id: string | null
 client_secret: string | null
}

export const SignIn = () => {
 const navigate = useNavigate()
 const {
  register,
  handleSubmit,
  formState: { errors },
 } = useForm<FormValues>()
 const [authenticateUser, isLoading] = useLoginMutation()
 const [error, setError] = useState("")

 // eslint-disable-next-line
 const onSubmit: SubmitHandler<FormValues> = (data) => {
  const formData = new FormData()
  formData.append("username", data.email)
  formData.append("password", data.password)
  formData.append("grant_type", data.grant_type || "null")
  formData.append("scope", data.scope || "null")
  formData.append("client_id", data.client_id || "null")
  formData.append("client_secret", data.client_secret || "null")

  authenticateUser(formData)
   .unwrap()
   .then((res: any) => {
    if (res?.access_token) {
     cookie.save("token", res.access_token, {
      maxAge: 365 * 24 * 60 * 60,
      path: "/",
     })
     navigate("/")
    }
   })
   .catch((e) => {
    console.log("e", e)
    setError(e.data?.msg)
   })
 }
 const [isPasswordVisible, setIsPasswordVisible] = useState(false)

 const togglePasswordVisibility = () => {
  setIsPasswordVisible((prevState) => !prevState)
 }
 useEffect(() => {}, [onSubmit])
 return (
  <Box bg="background" className="h-screen flex justify-center items-center">
   {isLoading.isLoading === true ? <SignInLoader /> : ""}
   <Box bg="background" className="absolute top-0 right-0 bottom-0 z-10 bg-highlight left-0"></Box>
   <Box className="lg:w-2/5 w-11/12 lg:mx-0 z-20 relative rounded-xl" color="text" bg="highlight">
    <div className="flex justify-end m-4">
     <div className="flex items-center">
      <p className="mx-2 font-bold">Lang:</p>
      <Language />
     </div>
    </div>
    <div className="flex justify-center  top-[-25px] lg:top-[-50px]  left-[40%] lg:left-0 lg:right-0 absolute lg:w-full w-[15%]">
     <img className="rounded-lg xl" src={logo} width={100} alt="stuhrenberg" />
    </div>
    <form
     className="flex pt-5 flex-col justify-center items-center"
     onSubmit={handleSubmit(onSubmit)}
    >
     <div className="w-4/5 my-3">
      <p>Email</p>
      <input
       className="bg-gray text-black focus:outline-yellow rounded w-full px-3 py-2"
       type="email"
       {...register("email", { required: true })}
       placeholder="email@mail.com"
      />
      {errors.email && <p className="text-red">Email is required</p>}
     </div>

     <div className="w-4/5 my-3">
      <p>Password</p>
      <div className="w-full relative">
       <input
        className="bg-gray text-black focus:outline-yellow rounded px-3 w-full py-2"
        type={isPasswordVisible ? "text" : "password"}
        {...register("password", { required: true })}
        placeholder="Password"
       />
       <div
        className="absolute cursor-pointer inset-y-0 right-0 bottom-0 flex items-center mx-4 text-gray-600"
        onClick={togglePasswordVisibility}
       >
        {isPasswordVisible ? (
         <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
         >
          <path
           strokeLinecap="round"
           strokeLinejoin="round"
           d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
          />
         </svg>
        ) : (
         <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
         >
          <path
           strokeLinecap="round"
           strokeLinejoin="round"
           d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
          />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
         </svg>
        )}
       </div>
      </div>
      {errors.password && <p className="text-red">password is required</p>}
     </div>
     <p className="text-red">{error}</p>
     <div className="py-5 lg:w-1/3 w-[40%]">
      <Button size="xl" color="yellow">
       Sign In
      </Button>
     </div>
    </form>
   </Box>
  </Box>
 )
}
